import {Button} from 'antd';
import {RiShoppingBagLine} from 'react-icons/ri';
import {Link} from 'react-router-dom';

import collection2 from '../../../assets/KalapiBridalCollection.jpeg';
import collection1 from '../../../assets/KalapiStyleBag.jpeg';

const FeaturedCollection = () => {
  return (
    <div className={'w-full mt-4 flex flex-col justify-center items-center'}>
      <h2 data-aos={'fade-up'} className={'title mb-6'}>
        Featured Collection
      </h2>

      <div className={'section relative md:p-10 p-6 mx-auto grid grid-cols-1 lg:grid-cols-5 items-center'}>

        {/* Desktop Images */}
        <div data-aos={'fade-up'} className={'md:flex hidden justify-center items-center col-span-3'}>
          <div className={'relative flex justify-center items-center'}>

            {/* Large Image */}
            <div className={'overflow-hidden  rounded-md shadow-lg ml-14'}>
              <img
                src={collection1}
                data-aos={'fade-left'}
                data-aos-duration={'900'}
                data-aos-easing={'ease-out-cubic'}
                className={'h-[300px] md:h-[400px] transition-transform duration-500 ease-out hover:scale-105'}
                alt={'Kalapi Store'}
              />
            </div>

            {/* Small Image */}
            <div className={'absolute -left-40 top-50 overflow-hidden rounded-md shadow-lg z-10'}>
              <img
                src={collection2}
                data-aos={'fade-right'}
                data-aos-duration={'900'}
                data-aos-easing={'ease-out-cubic'}
                className={'h-[150px] md:h-[250px]  transition-transform duration-500 ease-out hover:scale-105'}
                alt={'Kalapi Store'}
              />
            </div>

          </div>
        </div>

        {/* Mobile Images */}
        <div data-aos={'fade-up'} className={'md:hidden flex justify-center items-center'}>
          <div className={'relative flex justify-center items-center'}>

            <div className={'overflow-hidden rounded-md shadow-lg ml-24'}>
              <img
                src={collection1}
                data-aos={'fade-left'}
                data-aos-duration={'900'}
                data-aos-easing={'ease-out-cubic'}
                className={'h-[230px] w-[230px] transition-transform duration-500 ease-out hover:scale-105'}
                alt={'Kalapi Store'}
              />
            </div>

            <div className={'absolute -left-12 top-50 ml-8 overflow-hidden  rounded-md shadow-lg z-10'}>
              <img
                src={collection2}
                data-aos={'fade-right'}
                data-aos-duration={'900'}
                data-aos-easing={'ease-out-cubic'}
                className={'h-[140px]  transition-transform duration-500 ease-out hover:scale-105'}
                alt={'Kalapi Store'}
              />
            </div>

          </div>
        </div>

        {/* Right Side Text */}
        <div data-aos={'fade-up'} className={'p-2 col-span-2 md:mt-0 mt-6 flex flex-col'}>
          <p className={'text-primary-950 md:text-lg text-base font-medium font-serif leading-relaxed mb-2'}>
            Handpicked styles crafted with elegance and premium quality. Discover designs that blend modern trends with timeless appeal. Each piece is curated to elevate your everyday look effortlessly. Experience comfort, durability, and unmatched craftsmanship.
          </p>

          <p className={'text-primary-950 font-serif md:text-lg text-base font-medium leading-relaxed'}>
            At Kalapi Store, we showcase bags from trusted brands that reflect luxury appeal, youthful energy, and budget-friendly choices — all in one curated destination. Whether you prefer bold trends or classic elegance, our collection is designed to match your personality and elevate your everyday style with confidence.
          </p>

          <Link className={'mt-4'} to={'/product'}>
            <Button className={'flex font-serif items-center justify-center px-6 py-4 font-semibold text-white bg-primary-800 hover:!bg-primary-900 rounded-md shadow transition'}>
              <RiShoppingBagLine className={'mr-2 text-lg'} />
              Shop Now
            </Button>
          </Link>
        </div>

      </div>
    </div>
  );
};

export default FeaturedCollection;
